import React from "react";
import { useContext } from "react";
import { Context } from "../context";
import { CommentIcon } from "../utils/icons";
import { humanizeDate } from "../utils/datetimes";
import { breakpoint1 } from "../utils/styles";
import Image from "../components/Image";

const Recommended = ({ items }) => {
  const { theme } = useContext(Context);
  return (
    <div className="recommends">
      <style jsx>{`
        .recommends :global(.icon) {
          fill: ${theme.primaryIconColor};
        }
        .heading {
          margin: 2rem 0 1rem 0;
          display: flex;
          justify-content: center;
        }
        .heading h3 {
          font-size: 1.8rem;
        }
        .heading :global(.badge) {
          width: 2.1rem;
          height: 2.1rem;
          margin-right: 0.5rem;
        }
        .post {
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid ${theme.borderColor};
          padding: 1rem 0;
          text-decoration: none;
        }
        .meta {
          width: 100%;
          display: flex;
          align-items: center;
        }
        .meta span {
          margin-right: 0.5rem;
        }
        .text {
          margin-top: 0.5rem;
          margin-left: 1rem;
          color: ${theme.accentTextColor};
          font-weight: bold;
        }
        .text :global(.comment-icon) {
          fill: ${theme.accentTextColor};
        }

        .post:hover .image {
          opacity: 0.8;
        }
        .title {
          margin-top: 1rem;
          font-weight: bold;
          display: block;
          color: ${theme.primaryTextColor};
        }
        .post:hover .title {
          text-decoration: underline;
        }
      `}</style>
      <div className="heading">
        <img src="/images/brand.png" alt="AppCheeta" className="badge" />
        <h3>Recommended</h3>
      </div>
      <div className="listings">
        {items.map((entry) => (
          <a className="post" key={entry.slug} href={`/${entry.type}/${entry.slug}`}>
            <Image path={entry.image} width={330} height={330 * 0.5625} />
            <div className="text">
              <div className="meta">
                <span className="time">{humanizeDate(new Date(entry.modified))}</span>
                <span className="separator">-</span>
                <span className="icon-container">
                  <CommentIcon />
                </span>
                <span className="comment-count">{entry.comments || 0}</span>
              </div>
              <div className="title">{entry.title}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Recommended;
